import { VText } from '@vake/ui-kit';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import constants from '../../../shared/constants';
import { Button, ButtonLink } from '../../../shared/styles/Buttons';
import { SectionIntro } from '../../../shared/styles/TextFields';

const Card = styled.div<{ background: string }>`
    padding: 20px;
    display: flex;
    flex-direction: column;
    background: ${(props) => props.background};
    border-radius: 5px;
    width: calc(33% - 60px);
    @media screen and (max-width: ${constants.breakpoints.mobile}) {
        width: calc(100% - 40px);
        margin-bottom: 20px;
    }
`;

const Price = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    color: rgba(255, 255, 255, 0.7);
`;

const Column = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
`;
const Spacing = styled.div`
    display: flex;
    justify-content: space-between;
`;
const DeactivatedItem = styled.span`
    color: rgba(255, 255, 255, 0.7);
`;
interface IPlan {
    background: string;
    heading: string;
    description: JSX.Element;
    price: JSX.Element;
    details: JSX.Element;
    report?: boolean;
}

const plans: IPlan[] = [
    {
        background:
            'linear-gradient(142.22deg, rgba(18, 179, 159, 0.2) 11.43%, rgba(255, 122, 0, 0.2) 73.3%, rgba(255, 0, 245, 0.2) 98.7%)',
        heading: 'VAKE Overwatch',
        description: (
            <span>
                Monitoring of <b>specific areas</b> - unlock Maritime Domain Awareness through AI vessel detections and
                AIS-fusion.
            </span>
        ),
        price: <></>,
        details: (
            <>
                <span>✓ Automatic Data Updates</span>
                <span>✓ Global Coverage</span>
                <span>✓ Seven years of analyzed data and counting</span>
                <span>✓ Support for multiple satellite sources</span>
            </>
        ),
        report: true,
    },
    {
        background:
            'linear-gradient(142.22deg, rgba(131,58,180,0.5) 11.43%, rgba(255, 122, 0, 0.2) 73.3%, rgba(253,187,45,0.2) 98.7%)',
        heading: 'VAKE Pathfinder',
        description: (
            <span>
                Monitor the tracks of <b>specific ships</b> - confirm AIS positions and fill in the gaps from periods of
                dark activity, through machine-learning ship detections.
            </span>
        ),
        price: <></>,
        details: (
            <>
                <span>✓ Global Coverage</span>
                <span>✓ Seven years of analyzed data and counting</span>
                <span>✓ Support for multiple satellite sources</span>
            </>
        ),
    },
    {
        background: 'rgba(58, 125, 255, 0.2)',
        heading: 'Custom Solutions',
        description: (
            <span>
                Tailored development or analysis for specific use cases leveraging our unique expertise in Geospatial
                Intelligence and Analysis
            </span>
        ),
        price: <></>,
        details: (
            <>
                <span>✓ Custom integration</span>
                <span>✓ One-to-one delivery</span>
                <span>✓ Support for multiple satellite sources</span>
            </>
        ),
    },
];

const Offerings: FC = () => (
    <div className="flex flex-col w-[1255px] max-w-[calc(100%-50px)] m-auto pt-16" id="offerings">
        <VText variant="H1">Products</VText>
        <SectionIntro>
            <VText>
                We cater to your needs and offer multiple modes of accessing our insights. Our data can either be
                integrated with your solutions and interfaces through our API, or viewed through VAKE's intelligent web
                interfaces that unlock analysis on another level.
            </VText>
        </SectionIntro>
        <div className="flex flex-wrap justify-between">
            {plans.map((plan, i) => {
                const planKey = `plan_${i}`;
                return <Plan key={planKey} plan={plan} />;
            })}
        </div>
    </div>
);

const Plan: FC<{ plan: IPlan }> = ({ plan }) => {
    return (
        <Card background={plan.background}>
            <div className="min-h-[350px]">
                <VText variant="H2">{plan.heading}</VText>
                <DeactivatedItem>
                    <VText>{plan.description}</VText>
                </DeactivatedItem>
                <Price>
                    <VText>{plan.price}</VText>
                </Price>
                <Column>
                    <VText>{plan.details}</VText>
                </Column>
            </div>
            <Spacing>
                <>
                    {plan.report && (
                        <Link to="/report-builder">
                            <Button
                                background="white"
                                style={{ marginRight: '15px' }}
                                onClick={() => {
                                    window.sa_event(
                                        () => `req_det_open_form_plans_on__${window.document.location.search}`
                                    );
                                }}
                            >
                                Try a free report
                            </Button>
                        </Link>
                    )}
                    <a href="mailto:connect@vake.ai">
                        <ButtonLink>Contact us</ButtonLink>
                    </a>
                </>
            </Spacing>
        </Card>
    );
};

export default Offerings;
